/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/no-duplicate-string */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Route } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  CignaForBrokersSharedUiModule,
  MatDialogModule,
} from '@cigna/cigna-for-brokers/shared/ui';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CignaForBrokersSharedGatewaysModule } from '@cigna/cigna-for-brokers/shared/gateways';
import { LayoutSecureComponent } from './layout-secure/layout-secure.component';
import { UiModalModule } from '@cigna/shared/angular/modal-ui';
import { EffectsModule } from '@ngrx/effects';
import { UiIconModule } from '@cigna/shared/angular/icon-ui';
import { TranslateModule } from '@ngx-translate/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CignaForBrokersSharedDataAccessModule } from '@cigna/cigna-for-brokers/shared/data-access';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CignaForBrokersShellUiModule } from '@cigna/cigna-for-brokers/shell/ui';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  AppstateEffects,
  AppstateService,
  ProfileResolver,
  NavResolver,
  CignaForBrokersShellDataAccessModule,
  AuthenticationGuard,
  PreLoginAuthenticationGuard,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { ContentBundleName } from '@cigna/cigna-for-brokers/shared/util';
import { ContentResolver } from '@cigna/shared/angular/resource-content-data-access';
import { SharedGatewaysModule } from '@cigna/shared/angular/gateways-util';
import { UiProgressModule } from '@cigna/shared/angular/progress-ui';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FooterSecureComponent } from './footer-secure/footer-secure.component';
import { FooterUnSecureComponent } from './footer-unsecure/footer-unsecure.component';
import { AnalyticsUiModule } from '@cigna/shared/angular/analytics-ui';
import { LayoutUnSecureComponent } from './layout-unsecure/layout-unsecure.component';
import { AuthGuardOkta } from './state/authguard-okta';
import { LogoutGuardOkta } from './state/logoutguard-okta';
import { CfbLogoutComponent } from './logout/cfb-logout.component';
import { LayoutCheckoutUnSecureComponent } from './layout-checkout-unsecure/layout-checkout-unsecure.component';

export const routes: Route[] = [
  {
    path: 'secure/authorize/implementation',
    resolve: {
      translation: ContentResolver,
      appData: ProfileResolver,
      navData: NavResolver,
    },
    data: { preloadContent: [ContentBundleName.CIGNAFORBROKERS] },
    loadChildren: () =>
      // eslint-disable-next-line @nx/enforce-module-boundaries
      import('@cigna/cigna-for-brokers/authorize-redirect-feature').then(
        (m) => m.CignaForBrokersAuthorizeRedirectFeatureModule,
      ),
  },
  {
    path: 'secure',
    resolve: {
      translation: ContentResolver,
      appData: ProfileResolver,
      navData: NavResolver,
    },
    data: { preloadContent: [ContentBundleName.CIGNAFORBROKERS] },
    component: LayoutSecureComponent,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/home').then(
            (m) => m.CignaForBrokersHomeModule,
          ),
      },
      {
        path: 'commercial/compensation',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/compensation-feature').then(
            (m) => m.CignaForBrokersCompensationFeatureModule,
          ),
      },
      {
        path: 'commercial/funding',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import(
            '@cigna/cigna-for-brokers/commercial-funding-solution-feature'
          ).then(
            (m) => m.CignaForBrokersCommercialFundingSolutionFeatureModule,
          ),
      },
      {
        path: 'pdp-home',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import(
            '@cigna/cigna-for-brokers/prescription-drug-plan-feature'
          ).then((m) => m.CignaForBrokersPrescriptionDrugPlanFeatureModule),
      },
      {
        path: 'commercial/book-of-business',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/book-of-business-feature').then(
            (m) => m.CignaForBrokersBookOfBusinessFeatureModule,
          ),
      },

      {
        path: 'broker-messages',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/messages-feature').then(
            (m) => m.CignaForBrokersMessagesFeatureModule,
          ),
      },
      {
        path: 'commercial/solutions-insights',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/solutions-insights-feature').then(
            (m) => m.CignaForBrokersSolutionsInsightsFeatureModule,
          ),
      },
      {
        path: 'commercial/marketing-materials',
        // eslint-disable-next-line sonarjs/no-identical-functions
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/marketing-materials/feature').then(
            (m) => m.CignaForBrokersMarketingMaterialsFeatureModule,
          ),
      },
      {
        path: 'commercial/learning',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/training-education-feature').then(
            (m) => m.CignaForBrokersTrainingEducationFeatureModule,
          ),
      },
      {
        path: 'education/insights',
        // eslint-disable-next-line sonarjs/no-identical-functions
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/training-education-feature').then(
            (m) => m.CignaForBrokersTrainingEducationFeatureModule,
          ),
      },
      {
        path: 'ma/compensation',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/ma-compensation-feature').then(
            (m) => m.CignaForBrokersMaCompensationFeatureModule,
          ),
      },
      {
        path: 'medicare-medicaid-eligibility',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import(
            '@cigna/cigna-for-brokers/medicare-medicaid-lookup-feature'
          ).then((m) => m.CignaForBrokersMedicareMedicaidLookupFeatureModule),
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import(
            '@cigna/cigna-for-brokers/post-login-contact-us-intuitive-feature'
          ).then(
            (m) => m.CignaForBrokersPostLoginContactUsIntuitiveFeatureModule,
          ),
      },
      {
        path: 'security-profile',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/security-profile-feature').then(
            (m) => m.CignaForBrokersSecurityProfileFeatureModule,
          ),
      },
      {
        path: 'new-security-profile',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/new-security-profile/feature').then(
            (m) => m.CignaForBrokersNewSecurityProfileFeatureModule,
          ),
      },
      {
        path: 'csb/incentives',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/csb-incentives-feature').then(
            (m) => m.CignaForBrokersCsbIncentivesFeatureModule,
          ),
      },
      {
        path: 'sgp/renewals',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/small-group-feature').then(
            (m) => m.CignaForBrokersSmallGroupFeatureModule,
          ),
      },
      {
        path: '**',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/home').then(
            (m) => m.CignaForBrokersPageNotFoundModule,
          ),
      },
    ],
  },
  {
    path: 'impersonator',
    loadChildren: () =>
      // eslint-disable-next-line @nx/enforce-module-boundaries
      import('@cigna/cigna-for-brokers/impersonator-feature').then(
        (m) => m.CignaForBrokersImpersonatorFeatureModule,
      ),
  },
  {
    path: 'public/logout',
    // canActivate: [LogoutGuardOkta],
    component: CfbLogoutComponent,
    loadChildren: () =>
      // eslint-disable-next-line @nx/enforce-module-boundaries, sonarjs/no-duplicate-string
      import('@cigna/cigna-for-brokers/login-data-access').then(
        (m) => m.CignaForBrokersLoginDataAccessModule,
      ),
  },
  {
    path: 'public/checkout-login',
    resolve: {
      translation: ContentResolver,
    },
    canActivate: [AuthGuardOkta],
    data: {
      preloadContent: [ContentBundleName.CIGNAFORBROKERS],
      isCheckOut: true,
    },
    component: LayoutCheckoutUnSecureComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/login-feature').then(
            (m) => m.CignaForBrokersLoginModule,
          ),
      },
    ],
  },
  {
    path: 'public',
    resolve: {
      translation: ContentResolver,
    },
    canActivate: [AuthGuardOkta],
    data: { preloadContent: [ContentBundleName.CIGNAFORBROKERS] },
    component: LayoutUnSecureComponent,
    children: [
      {
        path: 'login',
        // eslint-disable-next-line sonarjs/no-identical-functions
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/login-feature').then(
            (m) => m.CignaForBrokersLoginModule,
          ),
      },
      {
        path: 'mfa',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/mfa-feature').then(
            (m) => m.CignaForBrokersMfaFeatureModule,
          ),
      },
      {
        path: 'forgot-password',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/forgot-password-feature').then(
            (m) => m.CignaForBrokersForgotPasswordFeatureModule,
          ),
      },
      {
        path: 'forgot-username',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/forgot-username-feature').then(
            (m) => m.CignaForBrokersForgotUsernameFeatureModule,
          ),
      },
      {
        path: 'registration',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/registration-feature').then(
            (m) => m.CignaForBrokersRegistrationRoutingModule,
          ),
      },
      {
        path: 'campaign',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/registration-feature').then(
            (m) => m.CignaForBrokersCommercialCampaignModule,
          ),
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/contact-us-feature').then(
            (m) => m.CignaForBrokersContactUsFeatureModule,
          ),
      },
      {
        path: 'pre-login-contact-us',
        loadChildren: () =>
          import(
            '@cigna/cigna-for-brokers/pre-login-contact-us-intuitive-feature'
          ).then(
            (m) => m.CignaForBrokersPreLoginContactUsIntuitiveFeatureModule,
          ),
      },
      {
        path: '**',
        canActivate: [PreLoginAuthenticationGuard],
        // eslint-disable-next-line sonarjs/no-identical-functions
        loadChildren: () =>
          // eslint-disable-next-line @nx/enforce-module-boundaries
          import('@cigna/cigna-for-brokers/login-feature').then(
            (m) => m.CignaForBrokersLoginModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    CignaForBrokersSharedUiModule,
    CignaForBrokersSharedGatewaysModule,
    CignaForBrokersShellUiModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
    TranslateModule,
    UiIconModule,
    UiModalModule,
    UiProgressModule,
    CignaForBrokersSharedDataAccessModule,
    EffectsModule.forFeature([AppstateEffects]),
    NgIdleKeepaliveModule.forRoot(),
    SharedGatewaysModule,
    CignaForBrokersShellDataAccessModule,
    AnalyticsUiModule,
    FlexLayoutModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule,
  ],
  declarations: [
    LayoutSecureComponent,
    FooterSecureComponent,
    FooterUnSecureComponent,
    LayoutUnSecureComponent,
    LayoutCheckoutUnSecureComponent,
    CfbLogoutComponent,
  ],
  providers: [
    ProfileResolver,
    AppstateService,
    NavResolver,
    AuthGuardOkta,
    LogoutGuardOkta,
    AuthenticationGuard,
    PreLoginAuthenticationGuard,
    { provide: MAT_DIALOG_DATA, useValue: {} },
  ],
})
export class CignaForBrokersShellFeatureModule {}
